<section class="hero relative overflow-visible">
    <img
        class="hidden xl:block absolute top-0 left-0 w-full h-full"
        style="object-fit: cover; object-position: right center"
        [src]="image + '-1200.webp'"
        [srcset]="
            image + '-400.webp 400w, ' +
            image + '-800.webp 800w, ' +
            image + '-1200.webp 1200w, ' +
            image + '-1600.webp 1600w, ' +
            image + '-2000.webp 2000w'
        "
        sizes="100vw"
        alt=""
    />

    <div
        class="hero-copy relative h-full mx-auto px-3 md:px-5 pt-5 xl:pt-0 xl:pb-7 flex flex-column align-items-start justify-content-center gap-3"
        style="max-width: 1280px"
    >
        <span class="text-xl font-bold text-900 line-height-1">Premium<span class="text-primary">+</span></span>
        <h1
            class="m-0 font-bold text-900 text-4xl md:text-5xl xl:text-6xl"
            style="max-width: 560px; letter-spacing: -0.01em; line-height: 1.1; text-wrap: balance"
        >
            {{ heading }}
        </h1>
        <p class="m-0 text-blue-900 text-base md:text-lg line-height-3" style="max-width: 520px; text-wrap: pretty">{{ subheading }}</p>
        <ng-content></ng-content>
    </div>
</section>
